import {
  convertFromIPaginationQueryToIPaginationQueryRequest,
  IPaginationQueryRequest,
} from './IPaginationQueryRequest';
import { convertFromISortQueryToISortQueryRequest, ISortQueryRequest } from './ISortQueryRequest';
import { IPaginationQuery } from './IPaginationQuery';
import { ISortQuery } from './ISortQuery';

export interface IPaginationSortQuery extends IPaginationQuery, ISortQuery {}
export interface IPaginationSortQueryRequest extends IPaginationQueryRequest, ISortQueryRequest {}

export function convertFromIPaginationSortQueryToIPaginationSortQueryRequest<T extends IPaginationSortQuery>({
  pageNumber: pageNumberQuery,
  pageSize: pageSizeQuery,
  sortField,
  sortOrder,
  ...rest
}: T): IPaginationSortQueryRequest {
  // sortField and sortOrder are combined into SortBy (e.g. 'fullName.asc')
  const { sortBy } = convertFromISortQueryToISortQueryRequest({ sortField, sortOrder });
  // pageNumber is reduced by 1
  const { pageNumber, pageSize } = convertFromIPaginationQueryToIPaginationQueryRequest({
    pageNumber: pageNumberQuery,
    pageSize: pageSizeQuery,
  });
  return { sortBy, pageNumber, pageSize, ...rest };
}
